import { P2GSidePanel } from '@parcel2go/legacy-my-account-core/dist/sidepanel';
import { P2GAlert } from '@parcel2go/peacock-legacy-core/dist/alert';
import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import { P2GLink } from '@parcel2go/peacock-legacy-core/dist/link';
import { P2GLinkGroup } from '@parcel2go/peacock-legacy-core/dist/linkgroup';
import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';
import React, { useState } from 'react';
import { ActionType } from '../services/api/types';
import { NotificationModel } from './AccountNotifications';
import AccountNotificationWhatsNext from './AccountNotificationWhatsNext';
import ActionInstructions from './ActionInstructions';

interface props {
  notification: NotificationModel;
  onClose: (accountId: string) => void;
}

const AccountNotification: React.FC<props> = (props) => {
  const [action, setAction] = useState<ActionType>('');

  const actions = props.notification.actions
    .map((a) => <P2GLink onClick={() => setAction(a)}>{a}</P2GLink>)
    .concat(props.notification.showClose ? [<P2GLink onClick={() => props.onClose(null)}>Close</P2GLink>] : []);

  return (
    <>
      <P2GAlert color={props.notification.color}>
        <P2GGrid container spacing={2} alignItems="center">
          <P2GGrid item flexGrow={1}>
            <P2GText component="p">{props.notification.note}</P2GText>
          </P2GGrid>
          {actions.length > 0 && (
            <P2GGrid item flexShrink={1}>
              <P2GLinkGroup links={actions} />
            </P2GGrid>
          )}
        </P2GGrid>
      </P2GAlert>
      <AccountNotificationWhatsNext onClose={() => setAction('')} notification={props.notification} />
      <P2GSidePanel open={!!action} onClose={() => setAction('')} anchor="right" width={'700px'} title={`${action}`}>
        <ActionInstructions
          key={action}
          integrationSlug={props.notification.integrationSlug}
          integrationType={props.notification.integrationType}
          configRequired={props.notification.configRequired}
          action={action}
          accountId={props.notification.accountId}
          onComplete={props.onClose}
        />
      </P2GSidePanel>
    </>
  );
};

export default AccountNotification;
